export const setDefaultPartnerIntegrationForm = ()         => dispatch => dispatch({ type: `SET-DEFAULT-PARTNER-INTEGRATION-FORM` } );
export const setPartnerIntegrationData = ( payload ) => dispatch => dispatch({type:'SET-PARTNER-INTEGRATION-DATA', payload})
